import React from 'react'

interface Props {
  numPages: number
  page: number

  setPage(page: number): void
}

const ProductFeedbacksPaginator: React.FC<Props> = props => {
  const { page, numPages, setPage } = props
  if (numPages < 2) {
    return null
  }

  return (
    <div className='paginator product-feedbacks'>
      {page > 1 && (
        <span
          className='prev-arrow product-feedbacks__arrow flex items-center'
          onClick={() => {
            setPage(page - 1)
          }}
        />
      )}
      <div className='page-num'>
        {page}/{numPages}
      </div>
      {page < numPages && (
        <span
          className='next-arrow product-feedbacks__arrow flex items-center'
          onClick={() => {
            setPage(page + 1)
          }}
        />
      )}
    </div>
  )
}

export default ProductFeedbacksPaginator
